import StorageNotAvailableException from '../exceptions/StorageNotAvailableException';
/**
 * full capability test for localstorage with iOS private browsing protection
 */
function storageAvailable() {
    let storage;
    try {
        storage = window.localStorage;
        const x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
        // eslint-disable-next-line no-unused-vars
    }
    catch (e) {
        return false;
    }
}
export function addToLocalStorage(key, value, expiry) {
    if (!storageAvailable()) {
        throw new StorageNotAvailableException();
    }
    const item = {
        value,
        ...(expiry ? { expiry } : {})
    };
    localStorage.setItem(key, JSON.stringify(item));
}
export function getValueFromLocalStorage(key) {
    if (!storageAvailable()) {
        throw new StorageNotAvailableException();
    }
    const item = localStorage.getItem(key);
    if (item === null) {
        return null;
    }
    const { value, expiry } = JSON.parse(item);
    if (expiry && new Date().getTime() > expiry) {
        localStorage.removeItem(key);
        return null;
    }
    return value;
}
